import React from "react";
import MoreOptions from "../../shared-ui/more-options";
import { IPopupMenuOption } from "../../shared-ui/popup-menu";
import { IDeletedConfigurationListItem } from "api/entities/deleted-config";
import { useApi } from "utils/hooks/use-api";
import { deletedConfigService } from "api/services/deleted-config-service";

export interface IMoreOptionProps {
  data: IDeletedConfigurationListItem;
}

export const MoreOption = (props: IMoreOptionProps) => {
  const [api] = useApi();
  const handleDownload = async () => {
    const buffer = await deletedConfigService.download(props.data.id); // arrayBuffer
    const array = new Uint8Array(buffer);

    const blob = new Blob([array], { type: "application/zip" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `deleted-configuration-${props.data.bucket}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  function getOptions(): IPopupMenuOption[] {
    const result = [
      {
        label: "Download",
        onClick: handleDownload,
      },
    ];
    return result;
  }

  return <MoreOptions options={getOptions()} />;
};
